import apiClient from '@/constants/http';
import { isNoResponse } from '@/utils/apiErrors';
import { Logger } from '@/utils/logging';

/** The signed-in session's own customer id, as squire-api resolves it. */
export const fetchSessionCustomerId = async (): Promise<string | null> => {
  try {
    const { data } = await apiClient.get<{ customer?: { id: string } }>(
      '/v1/user/session',
      { params: { include: 'customer' } },
    );
    return data.customer?.id ?? null;
  } catch (error) {
    const log = isNoResponse(error) ? Logger.warn : Logger.error;
    log('Could not resolve the session customer', { error });
    throw error;
  }
};
